import {
  METRIC_TYPE_METADATA,
  METRIC_TYPE_PROFILE_MEMBERS,
} from "src/generated/backendMetadata";
import type { MetricTypeData, MetricTypesResponse } from "./metricTypes";

/**
 * Metric metadata is generated from backend/app/shared_metadata/metric_types.csv at build time,
 * so these read a module constant rather than /api/info. They keep the `use` prefix and
 * their old return types so call sites are unchanged.
 */

const metricTypes = METRIC_TYPE_METADATA as MetricTypesResponse["metric_types"];

const metricTypesProfiles = Object.fromEntries(
  Object.entries(METRIC_TYPE_PROFILE_MEMBERS).map(([profile, metricTypeKeys]) => [
    profile,
    metricTypeKeys.map((name) => metricTypes[name]),
  ])
) as {
  [key in keyof MetricTypesResponse["metric_types_profiles"]]: MetricTypeData[];
};

export const useMetricTypes = () => metricTypes;

export const useMetricTypesProfiles = () => metricTypesProfiles;
